export const MESSAGE_USER_TYPES = {
  INTERNAL_USER: 'internal_user',
  CHAT_TEMP_USER: 'chat_temp_user',
  SYSTEM: 'system',
};

export const MESSAGE_SUPPORT_AGENT_TYPE = 'staff';
export const MESSAGE_USER_TYPES_LIST = Object.values(MESSAGE_USER_TYPES);

export const REPLY_SYMBOL = '&#8618;';

export const MESSAGE_TYPES = {
  OPEN: 'open',
  MESSAGE: 'message',
  JOIN: 'join',
  ATTACHMENT: 'attachment',
  TICKET: 'ticket',
  TICKET_CREATED: 'ticketCreated',
  NOTIFICATION: 'notification',
  ASK_EMAIL: 'askEmail',
  DIVIDER: 'divider',
  FEEDBACK: 'feedback',
  QUICK_ACTIONS: 'quickActions',
  CHAT_IS_CLOSED: 'chatClosed',
  TRANSFER: 'transfer',
  CALLBACK: 'callback',
  SYSTEM: 'system',
};
